import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Utils } from '../utils';
import { UserContext } from '../_models/user-context';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (Utils.isUserLogged()) {
            let user = Utils.getUserContext();
/*
            if (user.authConfirmRequired) {
                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                return false;
            } else if (user.pwdChangeRequired) {
                this.router.navigate(['/cambioPassword'], { queryParams: { returnUrl: state.url } });
                return false;
            }
            else
                return true;
                */
               return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/_guard/auth.guard.ts